import { apiFetch } from "@/lib/api-fetch";

export async function sendFriendRequestAction(recipientId: string): Promise<{ success: boolean }> {
  const res = await apiFetch("/api/friends/requests", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ recipientId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error || "Failed");
  }
  return { success: true };
}

export async function acceptFriendRequestAction(requestId: string): Promise<{ success: boolean }> {
  const res = await apiFetch(`/api/friends/requests/${encodeURIComponent(requestId)}/accept`, {
    method: "POST",
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error || "Failed");
  }
  return { success: true };
}

export async function rejectFriendRequestAction(requestId: string): Promise<{ success: boolean }> {
  const res = await apiFetch(`/api/friends/requests/${encodeURIComponent(requestId)}/reject`, {
    method: "POST",
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error || "Failed");
  }
  return { success: true };
}

export async function removeFriendAction(friendId: string): Promise<{ success: boolean }> {
  const res = await apiFetch(`/api/friends/${encodeURIComponent(friendId)}`, { method: "DELETE" });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error || "Failed");
  }
  return { success: true };
}
